/* Kheir — homepage scroll pacing
   Fades/rises in each homepage section as it enters view. Skips the hero
   (it has its own native reveal) and the footer (should not fade). */
(function () {
  function init() {
    var sections = document.querySelectorAll('main#main > .shopify-section');
    if (!sections.length) return;

    var targets = [];
    sections.forEach(function (el, index) {
      if (index === 0) return; // hero handles its own reveal
      if (el.id === 'shopify-section-footer') return;
      el.classList.add('kheir-reveal-init');
      targets.push(el);
    });

    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('kheir-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kheir-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
